import { createFeatureSelector } from '@ngrx/store';
import * as fromViewState from '../reducers';

export const selectViewState = createFeatureSelector<fromViewState.ViewState>(fromViewState.viewStateFeatureKey);
